export enum DiscountsRoutePathNames {
  DISCOUNTS = 'discounts',
  LIST = '',
  CREATE = 'create',
  UPDATE = ':id',
}
